<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8.00006H21" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 12.0001H21" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 16.0001H21" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 8.00006H3.01" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 12.0001H3.01" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3 16.0001H3.01" stroke="#C0C4CC" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'List',
  props: {

  },
  computed: {

  }
};
</script>
<style scoped lang="scss">

</style>
